import { render } from "./MapView.vue?vue&type=template&id=4d52a788"
import script from "./MapView.vue?vue&type=script&lang=js"
export * from "./MapView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/projects/laravel/gs1-ireland/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__